import { render } from "./Slide4.vue?vue&type=template&id=227e72b0&scoped=true"
import script from "./Slide4.vue?vue&type=script&lang=js"
export * from "./Slide4.vue?vue&type=script&lang=js"

import "./Slide4.vue?vue&type=style&index=0&id=227e72b0&lang=scss&scoped=true"
import "./Slide4.vue?vue&type=style&index=1&id=227e72b0&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227e72b0"]])

export default __exports__